module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav-bar', {
    attrs: {
      "title": "Smoothing Scroll"
    }
  }), _vm._v(" "), _c('scroller', {
    ref: "my_scroller",
    staticStyle: {
      "top": "44px"
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      staticClass: "row",
      class: {
        'grey-bg': index % 2 == 0
      }
    }, [_vm._v("\n      " + _vm._s(item) + "\n    ")])
  })), _vm._v(" "), _c('div', {
    staticClass: "info-position"
  }, [_vm._v(_vm._s(_vm.x + ',' + _vm.y))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d83d7d8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./demo/components/SmoothingScroll.vue
// module id = 45
// module chunks = 0